// The generated bitmap includes transparent margins. Position its visible
// silhouette in the same 62x73 web crop / 60x60 native canvas as pin_smallhit.png
// and pin.png, respectively. Keep the bitmap square to preserve the artwork.
export const referralPinWebFrame = { width: 62, height: 73 };
export const referralPinWebImage = { width: 115, height: 115, left: -26.1, top: -22 };
export const referralPinNativeImage = { width: 80.23, height: 80.23, left: -9.86, top: -6.98 };
